import { createSlice } from '@reduxjs/toolkit';
import {
  fetchClientOrderDisplay,
  fetchClientTextOrderDisplay,
} from './features';

export const clientOrderDisplay = createSlice({
  name: 'clientOrderDisplay',
  initialState: {
    order: null,
    status: '',
    textList: [],
    remainingTextAmount: 0,
    minWords: null,
    maxWords: null,
    isLoading: true,
    isError: true,
    isTextLoading: false,
    isTextError: false,
  },
  reducers: {
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    updateTextOfTextList: (state, { payload }) => {
      let array = [...state.textList];
      let index = array.findIndex((text) => text.id === payload.id);
      if (index > -1) {
        array[index][payload.key] = payload.value;
        state.textList = [...array];
      }
    },

    updateDeployedTexts: (state, { payload }) => {
      // Creating a new array with updated items
      const updatedTextList = state.textList.map((text) => {
        const deployItem = payload.find((item) => item.id === text.id);
        return deployItem
          ? { ...text, url: deployItem.url, deployed: true }
          : text;
      });

      state.textList = [...updatedTextList];
    },
    clientUpdateTextsOfTextList: (state, action) => {
      const updatedTextList = state.textList.map((text) =>
        action.payload.selectedTexts.includes(text.id)
          ? { ...text, [action.payload.key]: action.payload.value }
          : text
      );

      return {
        ...state,
        textList: updatedTextList,
      };
    },

    clientValidateAllTexts: (state, { payload }) => {
      let array = [...state.textList];
      array.forEach((text) => text.validated === 'true');
      state.textList = array;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchClientOrderDisplay.fulfilled, (state, { payload }) => {
        state.order = payload;
        state.minWords = payload.minWords;
        state.maxWords = payload.maxWords;
        state.isLoading = false;
        state.isError = false;
      })
      .addCase(fetchClientOrderDisplay.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(fetchClientOrderDisplay.rejected, (state) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(fetchClientTextOrderDisplay.fulfilled, (state, { payload }) => {
        state.textList = payload.map((text, index) => ({
          index,
          ...text,
        }));
        state.isTextLoading = false;
        state.isTextError = false;
      })
      .addCase(fetchClientTextOrderDisplay.pending, (state) => {
        state.isTextLoading = true;
        state.isTextError = false;
      })
      .addCase(fetchClientTextOrderDisplay.rejected, (state) => {
        state.isTextLoading = false;
        state.isTextError = true;
      });
  },
});

export default clientOrderDisplay.reducer;

export const {
  setStatus,
  updateTextOfTextList,
  updateTextListDetails,
  updateDeployedTexts,
  clientUpdateTextsOfTextList,
  clientValidateAllTexts,
} = clientOrderDisplay.actions;

export const clientOrderDisplaySelector = (state) => state.clientOrderDisplay;
